import $ from 'cash-dom'
import Cookies from '../utils/cookies'

export default class PopupModal {
  constructor({ $container }) {
    this.$container = $container

    this.constructElements()

    this.constructEvents()

    this.constructModal()
  }

  static init() {
    const $containers = $(PopupModal.selectors.container)

    if ($containers.length) {
      $containers.each((i, elem) => {
        const constructed = new PopupModal({ $container: $(elem) })
      })
    }
  }

  constructElements() {
    this.$body = $('body')
    this.$close = this.$container.find(PopupModal.selectors.close)
    this.$inner = this.$container.find(PopupModal.selectors.inner)
  }

  constructEvents() {
    this.$container
      .on('click', PopupModal.selectors.container, (e) => this.handleClick({ e }))
  }

  constructModal() {
    this.blockId = this.getBlockId()
    this.params = this.getParams()

    if (Cookies.get(this.params.cookie_name)) {
      return
    }

    this.doOpenModal()
  }

  doCloseModal() {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        this.$body.removeClass(PopupModal.classes.bodyOpen)
        this.$container.removeClass(PopupModal.classes.active)
      })
    })
  }

  doOpenModal() {
    setTimeout(() => {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          this.$body.addClass(PopupModal.classes.bodyOpen)
          this.$container.addClass(PopupModal.classes.active)
        })
      })

      Cookies.set(this.params)
    }, (this.params['delay_timer'] * 1000))
  }

  getBlockId() {
    return this.$container.attr('id')
  }

  getParams() {
    return ajax_query[this.blockId]
  }

  handleClick({ e }) {
    if(!$(e.target).closest(this.$inner).length) {
      this.doCloseModal()
    }
  }
}

PopupModal.selectors = {
  container: '.js-popup-modal',
  close: '.js-popup-modal-close',
  inner: '.js-popup-modal-inner',
}

PopupModal.classes = {
  active: 'c-popup-modal--active',
  bodyOpen: 'open-popup-modal',
}
